import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"

import { apiAreas } from "~/routes"

import PageContainer from "~/library/PageContainer"
import AreaForm from "~/components/AreaForm"

const NewArea = () => {
  const { venueSlug } = getAppConfig()
  const [createdAreaId, setCreatedAreaId] = useState(null)

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      area: formValues,
    }

    const req = apiAreas.create({ data })
    req.then(({ area }) => {
      setCreatedAreaId(area.id)
    })
  }

  if (createdAreaId) {
    return <Navigate to={`/areas/${createdAreaId}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">New Bookable Area</h3>
          <AreaForm onSubmit={handleSubmit} />
        </div>
      </div>
    </PageContainer>
  )
}

export default NewArea
